var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgConfirmed = function SvgConfirmed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DDA50D",
    d: "M14.056 0H.944C.424 0 0 .332 0 .744v15.658c0 .357.276.5.397.546.068.025.173.052.303.052.156 0 .3-.04.426-.12l6.36-2.916h.021c.018.012.036.02.056.028l6.258 2.86c.156.098.323.146.494.146.126 0 .226-.028.288-.05.12-.046.397-.187.397-.546V.744c0-.41-.423-.744-.944-.744z",
    transform: "rotate(90 11.5 11.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7B500",
    d: "M13.125 1v13.656l-5.574-2.404c-.19-.092-.424-.144-.664-.144-.235 0-.451.047-.61.136L1.143 15 1.125 1.341l12-.341z",
    transform: "rotate(90 11.5 11.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC7A",
    d: "M13 1v.975l-5.574-.171c-.19-.007-.424-.01-.664-.01-.235 0-.451.003-.61.01L1.018 2 1 1.024 13 1z",
    transform: "rotate(90 11.5 11.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDC7A",
    d: "M13 11h-1.95l.343-4.645c.013-.158.02-.353.02-.554 0-.195-.007-.375-.02-.507L11 1.015 12.951 1 13 11z",
    transform: "rotate(90 11.5 11.5)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConfirmed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/confirmed.6a93480e.svg";
export { ForwardRef as ReactComponent };